// Client-portal "who receives invoices" — see
// apps/invoicing/viewsets_recipients.py. The Guru chat tool changes the same
// list through the same backend service.
import api from '@src/api/clients';

const URL = 'dashboard/my-invoice-recipients/';

export const listMyInvoiceRecipients = () => api.request({ url: URL, method: 'GET' });

export const saveMyInvoiceRecipients = ({ scope, id, recipients }) =>
  api.request({ url: URL, method: 'POST', payload: { scope, id, recipients } });
